import React, { Component } from "react";

import {
  RiArrowDownSLine,
  RiCloseLine,
  RiMapPin2Line,
  RiSearchLine
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj, showHelpdesk } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

/* Tela /faq: o mesmo conteúdo do chatbot, em formato de consulta.

   As dúvidas vêm da mesma árvore que o chatbot usa (helpdesk/faqTheme/tree),
   já recortada pelo perfil ativo no backend — esta tela não filtra nada. Até
   outubro/2026 ela trazia uma lista escrita aqui no código, com o público de
   cada dúvida decidido no navegador; isso escondia sem impedir, e nada que se
   cadastrasse aparecia nela. Agora há uma fonte só, administrada em
   Help/Faq/List (menu Cadastros > FAQ).

   A organização segue a do chatbot: área → tópico → dúvida. Abas para as
   áreas (só quando o perfil tem mais de uma), índice de tópicos à esquerda e
   um tópico de cada vez à direita, com as dúvidas em acordeão. A busca cobre
   todas as áreas que o perfil vê. A resposta é buscada ao abrir, como no
   chatbot, e o "Abrir chamado" é o mesmo modal do header. */

/* Sem acento e em minúsculas, para a busca casar com o que se digita. */
const normalizar = texto =>
  String(texto || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

const MINIMO_BUSCA = 3;

class FaqList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tree: [],
      loading: true,
      areaId: null,
      topicoId: null,
      aberta: null,
      respostas: {},
      carregando: null,
      busca: ""
    };
  }

  componentDidMount() {
    this.montado = true;
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.carregar();
  }

  componentDidUpdate(prevProps) {
    if (this.roleId(prevProps) !== this.roleId(this.props)) {
      this.carregar();
    }
  }

  componentWillUnmount() {
    this.montado = false;
  }

  setSafeState(patch) {
    if (this.montado) {
      this.setState(patch);
    }
  }

  roleId(props) {
    return ((props.general || {}).active_roles || {}).role_id;
  }

  config() {
    return {
      headers: { authorization: `Bearer ${this.props.user.token}` },
      params: { role_id: this.roleId(this.props) }
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  carregar() {
    this.setState({ loading: true, aberta: null, respostas: {}, busca: "" });

    axios.get(`${URL.api}helpdesk/faqTheme/tree`, this.config()).then(
      resp => {
        const tree = ((resp.data && resp.data.data) || []).filter(temConteudo);
        const area = tree.find(no => no.home) || tree[0] || null;

        this.setSafeState({
          tree,
          loading: false,
          areaId: area ? area.id : null,
          topicoId: area ? primeiroTopico(area) : null
        });
      },
      error => {
        this.setSafeState({ loading: false });
        this.error(
          (error.response && error.response.statusText) ||
            "Não foi possível carregar as dúvidas frequentes."
        );
      }
    );
  }

  /* --------------------------------------------------------- navegação */

  area() {
    return this.state.tree.find(no => no.id === this.state.areaId) || null;
  }

  topicos(area) {
    if (!area) {
      return [];
    }

    const lista = (area.children || []).filter(temConteudo);

    // Dúvidas presas direto na área (sem tópico) viram uma entrada própria.
    if ((area.faqs || []).length) {
      lista.unshift({
        id: `geral-${area.id}`,
        name: "Dúvidas gerais",
        faqs: area.faqs,
        children: []
      });
    }

    return lista;
  }

  topico() {
    const lista = this.topicos(this.area());

    return lista.find(no => no.id === this.state.topicoId) || lista[0] || null;
  }

  escolherArea(area) {
    this.setState({
      areaId: area.id,
      topicoId: primeiroTopico(area),
      aberta: null,
      busca: ""
    });
  }

  escolherTopico(topico) {
    this.setState({ topicoId: topico.id, aberta: null, busca: "" });

    // A lista rola dentro do card; trocar de tópico começa pelo topo dela.
    if (this.corpo) {
      this.corpo.scrollTop = 0;
    }
  }

  /* Corpo rolável do card de dúvidas. O cabeçalho fica fora dele, fixo. */
  renderCorpo(conteudo) {
    return (
      <div
        className="faq-page__content-body"
        ref={el => {
          this.corpo = el;
        }}
      >
        {conteudo}
      </div>
    );
  }

  alternar(faq) {
    if (this.state.aberta === faq.id) {
      this.setState({ aberta: null });
      return;
    }

    this.setState({ aberta: faq.id });

    if (this.state.respostas[faq.id]) {
      return;
    }

    this.setState({ carregando: faq.id });

    axios
      .get(`${URL.api}helpdesk/faq/singleView/${faq.id}`, this.config())
      .then(
        resp => {
          const dados = (resp.data && resp.data.data) || null;

          this.setSafeState(prev => ({
            carregando: null,
            respostas: { ...prev.respostas, [faq.id]: dados }
          }));
        },
        () => {
          toastr.error(
            "Falha",
            "Não foi possível carregar a resposta dessa dúvida."
          );
          this.setSafeState({ carregando: null, aberta: null });
        }
      );
  }

  /* Busca por texto em todas as áreas que o perfil vê. A árvore já está em
     memória, então o filtro é local, sem ida ao servidor a cada tecla. */
  resultados() {
    const termo = normalizar(this.state.busca);

    if (termo.length < MINIMO_BUSCA) {
      return null;
    }

    const encontrados = [];
    const varias = this.state.tree.length > 1;

    const percorrer = (nos, trilha) => {
      nos.forEach(no => {
        const trilhaNo = trilha.concat([no.name]);

        (no.faqs || []).forEach(faq => {
          if (normalizar(faq.question).indexOf(termo) !== -1) {
            encontrados.push({
              faq,
              trilha: (varias ? trilhaNo : trilhaNo.slice(1)).join(" › ")
            });
          }
        });

        percorrer(no.children || [], trilhaNo);
      });
    };

    percorrer(this.state.tree, []);

    return encontrados;
  }

  /* --------------------------------------------------------- partes */

  renderResposta(faq) {
    const resposta = this.state.respostas[faq.id];

    if (this.state.carregando === faq.id || !resposta) {
      return (
        <div className="faq-page__loading">
          <Loading />
        </div>
      );
    }

    return (
      <>
        <p className="faq-page__answer-text">{resposta.answer}</p>

        {resposta.navigation_path && (
          <div className="faq-page__where">
            <RiMapPin2Line size={16} aria-hidden="true" />
            <span>
              <strong>Onde fica:</strong> {resposta.navigation_path}
            </span>
          </div>
        )}

        <div className="faq-page__answer-footer">
          {resposta.action_url && (
            <a
              href={resposta.action_url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-primary"
            >
              {resposta.action_label || "Acessar direcionamento"}
            </a>
          )}
          <span className="faq-page__ticket">
            Não resolveu?{" "}
            <button type="button" onClick={() => this.props.showHelpdesk()}>
              Abrir chamado
            </button>
          </span>
        </div>
      </>
    );
  }

  renderDuvida(faq, trilha) {
    const aberta = this.state.aberta === faq.id;
    const regiao = `faq-resposta-${faq.id}`;

    return (
      <div
        key={`q-${faq.id}`}
        className={`faq-page__item${aberta ? " is-open" : ""}`}
      >
        <button
          type="button"
          className="faq-page__question"
          onClick={() => this.alternar(faq)}
          aria-expanded={aberta}
          aria-controls={regiao}
        >
          <span className="faq-page__question-text">
            {trilha && <span className="faq-page__trail">{trilha}</span>}
            {faq.question}
          </span>
          <RiArrowDownSLine
            className="faq-page__chevron"
            size={20}
            aria-hidden="true"
          />
        </button>
        {aberta && (
          <div id={regiao} className="faq-page__answer">
            {this.renderResposta(faq)}
          </div>
        )}
      </div>
    );
  }

  /* Subtópicos viram seções do tópico, com o caminho no título quando estão
     mais de um nível abaixo. */
  renderSecoes(nos, trilha) {
    return nos.filter(temConteudo).map(no => {
      const nome = trilha.concat([no.name]);

      return (
        <section key={`s-${no.id}`} className="faq-page__section">
          <h3 className="faq-page__section-title">{nome.join(" › ")}</h3>
          {no.description && (
            <p className="faq-page__section-desc">{no.description}</p>
          )}
          {(no.faqs || []).map(faq => this.renderDuvida(faq))}
          {this.renderSecoes(no.children || [], nome)}
        </section>
      );
    });
  }

  renderIndice(topicos, atual) {
    return (
      <nav className="faq-page__index" aria-label="Tópicos">
        {topicos.map(topico => (
          <button
            key={`i-${topico.id}`}
            type="button"
            className={`faq-page__index-item${
              atual && atual.id === topico.id ? " is-active" : ""
            }`}
            aria-current={atual && atual.id === topico.id ? "true" : undefined}
            onClick={() => this.escolherTopico(topico)}
          >
            <span className="faq-page__index-name">{topico.name}</span>
            <span className="faq-page__count">{contarDuvidas(topico)}</span>
          </button>
        ))}
      </nav>
    );
  }

  renderTopico(topico) {
    if (!topico) {
      return null;
    }

    const total = contarDuvidas(topico);

    return (
      <>
        <div className="faq-page__content-header">
          <h2 className="faq-page__content-title">{topico.name}</h2>
          <span className="faq-page__content-meta">
            {total} {total === 1 ? "dúvida" : "dúvidas"}
          </span>
        </div>
        {this.renderCorpo(
          <>
            {topico.description && (
              <p className="faq-page__section-desc">{topico.description}</p>
            )}
            {(topico.faqs || []).map(faq => this.renderDuvida(faq))}
            {this.renderSecoes(topico.children || [], [])}
          </>
        )}
      </>
    );
  }

  renderBusca(resultados) {
    const termo = this.state.busca.trim();

    return (
      <>
        <div className="faq-page__content-header">
          <h2 className="faq-page__content-title">Resultados para “{termo}”</h2>
          <span className="faq-page__content-meta">
            {resultados.length} {resultados.length === 1 ? "dúvida" : "dúvidas"}
          </span>
        </div>
        {this.renderCorpo(
          resultados.length ? (
            resultados.map(item => this.renderDuvida(item.faq, item.trilha))
          ) : (
            <div className="faq-page__empty">
              <p>
                Nenhuma dúvida encontrada com esse termo. Tente outra palavra.
              </p>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => this.props.showHelpdesk()}
              >
                Abrir chamado
              </button>
            </div>
          )
        )}
      </>
    );
  }

  renderConteudo() {
    const { tree, busca } = this.state;

    if (!tree.length) {
      return (
        <div className="faq-page__card faq-page__empty">
          <p>
            Ainda não há dúvidas cadastradas para o seu perfil. Se precisar de
            ajuda, fale com o suporte.
          </p>
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={() => this.props.showHelpdesk()}
          >
            Abrir chamado
          </button>
        </div>
      );
    }

    const area = this.area();
    const topicos = this.topicos(area);
    const atual = this.topico();
    const resultados = this.resultados();

    return (
      <>
        {tree.length > 1 && (
          <div className="faq-page__areas" role="tablist" aria-label="Áreas">
            {tree.map(item => (
              <button
                key={`a-${item.id}`}
                type="button"
                role="tab"
                aria-selected={area && area.id === item.id}
                className={`faq-page__area${
                  area && area.id === item.id ? " is-active" : ""
                }`}
                onClick={() => this.escolherArea(item)}
              >
                {item.name}
              </button>
            ))}
          </div>
        )}

        <div className="faq-page__layout">
          {resultados === null && (
            <aside className="faq-page__card faq-page__sidebar">
              <div className="faq-page__sidebar-title">
                {area ? area.name : "Tópicos"}
              </div>
              {this.renderIndice(topicos, atual)}
            </aside>
          )}

          <div
            className={`faq-page__card faq-page__content${
              resultados === null ? "" : " faq-page__content--full"
            }`}
          >
            {resultados === null
              ? this.renderTopico(atual)
              : this.renderBusca(resultados)}
          </div>
        </div>

        {busca.trim() && busca.trim().length < MINIMO_BUSCA && (
          <p className="faq-page__hint">
            Digite ao menos {MINIMO_BUSCA} letras para buscar.
          </p>
        )}
      </>
    );
  }

  render() {
    const { loading, busca, tree } = this.state;

    return (
      <div id="list" className="faq-page animated fadeIn">
        <Breadcrumb current={this.props.currentRoute} />

        <div className="faq-page__header">
          <div>
            <h1 className="faq-page__title">Perguntas frequentes</h1>
            <p className="faq-page__subtitle">
              Encontre respostas rápidas sobre o uso da plataforma.
            </p>
          </div>
          {!loading && tree.length > 0 && (
            <div className="faq-page__search">
              <RiSearchLine
                className="faq-page__search-icon"
                size={17}
                aria-hidden="true"
              />
              <input
                type="text"
                className="form-control"
                placeholder="Buscar uma dúvida"
                aria-label="Buscar uma dúvida"
                value={busca}
                onChange={e => this.setState({ busca: e.target.value })}
              />
              {busca && (
                <button
                  type="button"
                  className="faq-page__search-clear"
                  aria-label="Limpar busca"
                  onClick={() => this.setState({ busca: "" })}
                >
                  <RiCloseLine size={16} />
                </button>
              )}
            </div>
          )}
        </div>

        {loading ? <Loading /> : this.renderConteudo()}

        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

/* O backend já tirou o que o perfil não vê; um nó sem nenhuma dúvida
   visível embaixo não aparece — um título sem conteúdo só confundiria. */
function temConteudo(no) {
  return (no.faqs || []).length > 0 || (no.children || []).some(temConteudo);
}

function contarDuvidas(no) {
  return (no.children || []).reduce(
    (total, filho) => total + contarDuvidas(filho),
    (no.faqs || []).length
  );
}

function primeiroTopico(area) {
  if ((area.faqs || []).length) {
    return `geral-${area.id}`;
  }

  const primeiro = (area.children || []).find(temConteudo);

  return primeiro ? primeiro.id : null;
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      showHelpdesk
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqList);
